import React from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"

import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { useNavigate } from "react-router-dom"
import upload from "../../assets/images/icons/upload.svg"
import archive from "../../assets/images/icons/archive.svg"
import { tenureOptions } from "helpers/utils"

const CreateREITs = () => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()

  //meta title
  document.title = "Register Wealth Partner"

  const validation = useFormik({
    initialValues: {
      issuer_name: "",
      sector: "",
      financial_highlights: "",
      website: "",
      file_browser: "",
      instrument_type: "",
      face_value: "",
      minimum_investment: "",
      rate_of_interest: "",
      interest_frequency: "",
      tenure: "",
      call_option: "",
      put_option: "",
      mode_of_issue: "",
      security: "",
      debenture_trustee: "",
      holding: "",
      credit_rating: "",
      credit_rating_agency_name: "",
      term_sheet: "",
      rating_rationale: "",
      others: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {},
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <CardTitle className="mb-4 mt-4">Add REIT</CardTitle>
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 gap-md-3   mb-4">
            <CardTitle>
              REIT Code: <span>IRT-REIT-2025</span>
            </CardTitle>
            <div className="card-title-right ">
              <div className="archive-section">
                <img src={archive} />
                <p>Archive REIT</p>
              </div>
              <div className="swich-box">
                <p>Active</p>
                <label className="switch">
                  <input type="checkbox" name="toggleOption" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>

          <Row>
            <Col xl={12}>
              <Form onSubmit={validation.handleSubmit}>
                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">Basic REIT Details</CardTitle>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Issuer Name <span className="error">*</span>
                        </Label>
                        <Input
                          name="issuer_name"
                          id="issuer_name"
                          type="text"
                          className="form-control"
                          placeholder="Investment Amount"
                          value={validation.values.issuer_name}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.issuer_name &&
                            validation.errors.issuer_name
                              ? true
                              : false
                          }
                        />
                        {validation.errors.issuer_name &&
                        validation.touched.issuer_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.issuer_name}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Sector <span className="error">*</span>
                        </Label>
                        <select
                          id="sector"
                          name="sector"
                          className="form-select pageSize"
                          value={validation.values.sector}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        >
                          {tenureOptions.map((item) => (
                            <option key={item.key}> {item.key}</option>
                          ))}
                        </select>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Financial Highlights <span className="error">*</span>
                        </Label>
                        <select
                          name="financial_highlights"
                          id="financial_highlights"
                          className="form-select pageSize"
                          value={validation.values.financial_highlights}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        >
                          {tenureOptions.map((item) => (
                            <option key={item.value}> {item.value}</option>
                          ))}
                        </select>
                      </Col>

                      <Col xl={6}>
                        <Label className="col-form-label">
                          Website <span className="error">*</span>
                        </Label>
                        <Input
                          name="website"
                          type="text"
                          className="form-control"
                          id="website"
                          placeholder="Investment Amount"
                          value={validation.values.website}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.website &&
                            validation.errors.website
                              ? true
                              : false
                          }
                        />
                        {validation.errors.website &&
                        validation.touched.website ? (
                          <FormFeedback type="invalid">
                            {validation.errors.website}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          File Browser <span className="error">*</span>
                        </Label>
                        <div className="upload-file-wrapper">
                          <Input
                            name="file_browser"
                            id="file_browser"
                            type="file"
                            className="form-control d-none"
                            placeholder="No file chosen"
                            onChange={(e) => {
                              const file = e.target.files[0]
                              if (file) {
                                validation.setFieldValue("file_browser", file)
                              }
                            }}
                          />

                          <Input
                            type="text"
                            className="form-control"
                            value={
                              validation.values.file_browser
                                ? validation.values.file_browser.name
                                : "No file chosen"
                            }
                            readOnly
                          />
                          <Button
                            type="button"
                            onClick={() =>
                              document.getElementById("file_browser").click()
                            }
                          >
                            Upload
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">Investment Details</CardTitle>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Instrument Type<span className="error">*</span>
                        </Label>
                        <Input
                          name="instrument_type"
                          type="text"
                          className="form-control"
                          id="instrument_type"
                          placeholder="Investment Amount"
                          value={validation.values.instrument_type}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.instrument_type &&
                            validation.errors.instrument_type
                              ? true
                              : false
                          }
                        />
                        {validation.errors.instrument_type &&
                        validation.touched.instrument_type ? (
                          <FormFeedback type="invalid">
                            {validation.errors.instrument_type}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Face Value <span className="error">*</span>
                        </Label>
                        <Input
                          name="face_value"
                          type="text"
                          className="form-control"
                          id="face_value"
                          placeholder="Investment Amount"
                          value={validation.values.face_value}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.face_value &&
                            validation.errors.face_value
                              ? true
                              : false
                          }
                        />
                        {validation.errors.face_value &&
                        validation.touched.face_value ? (
                          <FormFeedback type="invalid">
                            {validation.errors.face_value}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Minimum Investment<span className="error">*</span>
                        </Label>
                        <Input
                          name="minimum_investment"
                          type="text"
                          className="form-control"
                          id="minimum_investment"
                          placeholder="Investment Amount"
                          value={validation.values.minimum_investment}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.minimum_investment &&
                            validation.errors.minimum_investment
                              ? true
                              : false
                          }
                        />
                        {validation.errors.minimum_investment &&
                        validation.touched.minimum_investment ? (
                          <FormFeedback type="invalid">
                            {validation.errors.minimum_investment}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Rate of Interest<span className="error">*</span>
                        </Label>
                        <Input
                          name="rate_of_interest"
                          type="text"
                          className="form-control"
                          id="rate_of_interest"
                          placeholder="Investment Amount"
                          value={validation.values.rate_of_interest}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.rate_of_interest &&
                            validation.errors.rate_of_interest
                              ? true
                              : false
                          }
                        />
                        {validation.errors.rate_of_interest &&
                        validation.touched.rate_of_interest ? (
                          <FormFeedback type="invalid">
                            {validation.errors.rate_of_interest}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Interest Payment Frequency
                          <span className="error">*</span>
                        </Label>
                        <Input
                          name="interest_frequency"
                          type="text"
                          className="form-control"
                          id="interest_frequency"
                          placeholder="Investment Amount"
                          value={validation.values.interest_frequency}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.interest_frequency &&
                            validation.errors.interest_frequency
                              ? true
                              : false
                          }
                        />
                        {validation.errors.interest_frequency &&
                        validation.touched.interest_frequency ? (
                          <FormFeedback type="invalid">
                            {validation.errors.interest_frequency}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Tenure<span className="error">*</span>
                        </Label>
                        <Input
                          name="tenure"
                          type="text"
                          className="form-control"
                          id="tenure"
                          placeholder="Investment Amount"
                          value={validation.values.tenure}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.tenure &&
                            validation.errors.tenure
                              ? true
                              : false
                          }
                        />
                        {validation.errors.tenure &&
                        validation.touched.tenure ? (
                          <FormFeedback type="invalid">
                            {validation.errors.tenure}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Call Option<span className="error">*</span>
                        </Label>
                        <Input
                          name="call_option"
                          type="text"
                          className="form-control"
                          id="call_option"
                          placeholder="Investment Amount"
                          value={validation.values.call_option}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.call_option &&
                            validation.errors.call_option
                              ? true
                              : false
                          }
                        />
                        {validation.errors.call_option &&
                        validation.touched.call_option ? (
                          <FormFeedback type="invalid">
                            {validation.errors.call_option}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Put Option<span className="error">*</span>
                        </Label>
                        <Input
                          name="put_option"
                          type="text"
                          className="form-control"
                          id="put_option"
                          placeholder="Investment Amount"
                          value={validation.values.put_option}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.put_option &&
                            validation.errors.put_option
                              ? true
                              : false
                          }
                        />
                        {validation.errors.put_option &&
                        validation.touched.put_option ? (
                          <FormFeedback type="invalid">
                            {validation.errors.put_option}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Mode of Issue<span className="error">*</span>
                        </Label>
                        <Input
                          name="mode_of_issue"
                          type="text"
                          className="form-control"
                          id="mode_of_issue"
                          placeholder="Investment Amount"
                          value={validation.values.mode_of_issue}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.mode_of_issue &&
                            validation.errors.mode_of_issue
                              ? true
                              : false
                          }
                        />
                        {validation.errors.mode_of_issue &&
                        validation.touched.mode_of_issue ? (
                          <FormFeedback type="invalid">
                            {validation.errors.mode_of_issue}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Security<span className="error">*</span>
                        </Label>
                        <Input
                          name="security"
                          type="text"
                          className="form-control"
                          id="security"
                          placeholder="Investment Amount"
                          value={validation.values.security}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.security &&
                            validation.errors.security
                              ? true
                              : false
                          }
                        />
                        {validation.errors.security &&
                        validation.touched.security ? (
                          <FormFeedback type="invalid">
                            {validation.errors.security}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Debenture Trustee <span>(If applicable)</span>
                          <span className="error">*</span>
                        </Label>
                        <Input
                          name="debenture_trustee"
                          type="text"
                          className="form-control"
                          id="debenture_trustee"
                          placeholder="Investment Amount"
                          value={validation.values.debenture_trustee}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.debenture_trustee &&
                            validation.errors.debenture_trustee
                              ? true
                              : false
                          }
                        />
                        {validation.errors.debenture_trustee &&
                        validation.touched.debenture_trustee ? (
                          <FormFeedback type="invalid">
                            {validation.errors.debenture_trustee}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Holding<span className="error">*</span>
                        </Label>
                        <Input
                          name="holding"
                          type="text"
                          className="form-control"
                          id="holding"
                          placeholder="Investment Amount"
                          value={validation.values.holding}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.holding &&
                            validation.errors.holding
                              ? true
                              : false
                          }
                        />
                        {validation.errors.holding &&
                        validation.touched.holding ? (
                          <FormFeedback type="invalid">
                            {validation.errors.holding}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">Rating Details</CardTitle>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Credit Rating <span>(If applicable)</span>
                        </Label>
                        <Input
                          name="credit_rating"
                          type="text"
                          className="form-control"
                          id="credit_rating"
                          placeholder="Investment Amount"
                          value={validation.values.credit_rating}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.credit_rating &&
                            validation.errors.credit_rating
                              ? true
                              : false
                          }
                        />
                        {validation.errors.credit_rating &&
                        validation.touched.credit_rating ? (
                          <FormFeedback type="invalid">
                            {validation.errors.credit_rating}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Credit Rating Agency Name
                          <span className="error">*</span>
                        </Label>
                        <Input
                          name="credit_rating_agency_name"
                          type="text"
                          className="form-control"
                          id="credit_rating_agency_name"
                          placeholder="Investment Amount"
                          value={validation.values.credit_rating_agency_name}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.credit_rating_agency_name &&
                            validation.errors.credit_rating_agency_name
                              ? true
                              : false
                          }
                        />
                        {validation.errors.credit_rating_agency_name &&
                        validation.touched.credit_rating_agency_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.credit_rating_agency_name}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">Documents</CardTitle>
                    <Row className="mb-2">
                      <Col xl={4}>
                        <Label className="col-form-label">
                          Term Sheet <span className="error">*</span>
                        </Label>

                        <Input
                          name="term_sheet"
                          id="term_sheet"
                          type="file"
                          className="form-control d-none"
                          placeholder="No file chosen"
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file) {
                              validation.setFieldValue("term_sheet", file)
                            }
                          }}
                        />

                        <div
                          className="upload-doc"
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault()
                            const file = e.dataTransfer.files[0]
                            if (file) {
                              validation.setFieldValue("term_sheet", file)
                            }
                          }}
                          onClick={() =>
                            document.getElementById("term_sheet").click()
                          }
                        >
                          <div className="upload-icon-wrapper">
                            <img src={upload} alt="" />
                          </div>
                          <h5>
                            <span>Click to upload </span> or drag and drop
                          </h5>
                          <p>PDF or JPG (max. 5 MB)</p>
                          {validation.values.term_sheet && (
                            <span>{validation.values.term_sheet.name}</span>
                          )}
                        </div>
                      </Col>
                      <Col xl={4}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Rating Rationale
                          <span className="error">*</span>
                        </Label>
                        <Input
                          name="rating_rationale"
                          id="rating_rationale"
                          type="file"
                          className="form-control d-none"
                          placeholder="No file chosen"
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file) {
                              validation.setFieldValue("rating_rationale", file)
                            }
                          }}
                        />

                        <div
                          className="upload-doc"
                          onClick={() =>
                            document.getElementById("rating_rationale").click()
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault()
                            const file = e.dataTransfer.files[0]
                            if (file) {
                              validation.setFieldValue("rating_rationale", file)
                            }
                          }}
                        >
                          <div className="upload-icon-wrapper">
                            <img src={upload} alt="" />
                          </div>
                          <h5>
                            <span>Click to upload </span> or drag and drop
                          </h5>
                          <p>PDF or JPG (max. 5 MB)</p>
                          {validation.values.rating_rationale && (
                            <span>
                              {validation.values.rating_rationale.name}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col xl={4}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Others <span>(If any)</span>
                        </Label>
                        <Input
                          name="others"
                          id="others"
                          type="file"
                          className="form-control d-none"
                          placeholder="No file chosen"
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file) {
                              validation.setFieldValue("others", file)
                            }
                          }}
                        />

                        <div
                          className="upload-doc"
                          onClick={() =>
                            document.getElementById("others").click()
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault()
                            const file = e.dataTransfer.files[0]
                            if (file) {
                              validation.setFieldValue("others", file)
                            }
                          }}
                        >
                          <div className="upload-icon-wrapper">
                            <img src={upload} alt="" />
                          </div>
                          <h5>
                            <span>Click to upload </span> or drag and drop
                          </h5>
                          <p>PDF or JPG (max. 5 MB)</p>
                          {validation.values.others && (
                            <span>{validation.values.others.name}</span>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-end mt-4">
                      <Col sm={12}>
                        <div className="d-flex justify-content-end align-items-center gap-3">
                          <button type="submit" className="btn btn-cancel w-md">
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary w-md"
                          >
                            Submit
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateREITs
